import { useState, useEffect } from 'react';
import { getEventPreview } from '../lib/supabase';
import { toDisplayLong } from '../helpers';

const bottoneInvito = {
  width: "100%", justifyContent: "center", boxSizing: "border-box",
  fontSize: 19, fontWeight: 800, minHeight: 58, padding: "14px 16px", borderRadius: 14,
  whiteSpace: "normal", textAlign: "center", lineHeight: 1.25,
};

function EventPreview({ eventId, onLogin, onRegister }) {
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    // Prima si scaricavano tutti gli eventi, tutte le location e tutti i
    // musicisti per mostrarne uno solo. Ora si chiede una serata sola, e
    // senza toccare email o contatti di nessuno.
    const load = async () => {
      try {
        const ev = await getEventPreview(eventId);
        if (!ev) { setNotFound(true); return; }
        setEvent(ev);
      } catch { setNotFound(true); }
      finally { setLoading(false); }
    };
    load();
  }, [eventId]);

  if (loading) return (
    <div className="loading-screen"><div className="spinner"/></div>
  );

  if (notFound) return (
    <div style={{minHeight:"100vh",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:20,textAlign:"center"}}>
      <div style={{fontSize:20,fontWeight:700,marginBottom:8}}>Evento non trovato</div>
      <div style={{fontSize:16,color:"var(--muted)",marginBottom:24}}>Il link potrebbe essere scaduto o non valido.</div>
      <button className="btn btn-primary" onClick={onLogin}>Accedi</button>
    </div>
  );

  if (event.visibility === 'private') return (
    <div style={{minHeight:"100vh",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:20,textAlign:"center"}}>
      <div style={{fontSize:20,fontWeight:700,marginBottom:8}}>Evento privato</div>
      <div style={{fontSize:16,color:"var(--muted)",marginBottom:24,maxWidth:320}}>
        Questo evento è su invito. Contatta l'organizzatore per partecipare.
      </div>
      <button className="btn btn-primary" onClick={onLogin}>Accedi se hai già un account</button>
    </div>
  );

  const partCount = event.participantCount || 0;
  const partNames = (event.participantNames || []).map(n => n.split(" ")[0]).filter(Boolean);
  const locationLine = [event.city || event.venue?.city, event.venue?.name || event.location_name || event.location].filter(Boolean).join(" · ");

  return (
    <div style={{minHeight:"100vh",background:"var(--bg)",padding:"0 0 60px"}}>
      <div style={{maxWidth:480,margin:"0 auto",padding:"32px 20px"}}>

        {/* Chi apre il link d'invito vede l'immagine scelta per l'invito, la
            stessa dell'anteprima su WhatsApp. La locandina solo se l'immagine
            per l'invito non c'e'. */}
        {(event.invite_image_url||event.image_url)
          ? <img src={event.invite_image_url||event.image_url} alt={event.title}
              style={{width:"100%",borderRadius:16,marginBottom:24,objectFit:"cover",maxHeight:300}}/>
          : <div style={{height:4,background:"var(--grad)",borderRadius:999,marginBottom:28}}/>
        }

        <div style={{fontSize:32,fontWeight:900,color:"var(--text)",lineHeight:1.15,marginBottom:10}}>
          {event.title}
        </div>

        <div style={{fontSize:18,fontWeight:700,color:"var(--muted)",marginBottom:6}}>
          {toDisplayLong(event.date)}{event.time_start?` · ${event.time_start}${event.time_end?` → ${event.time_end}`:""}` : ""}
        </div>

        {locationLine&&<div style={{fontSize:16,color:"var(--muted)",marginBottom:16}}>{locationLine}</div>}

        {event.description&&(
          <div style={{fontSize:16,color:"var(--text)",lineHeight:1.7,marginBottom:20,padding:"14px 16px",background:"var(--surface)",borderRadius:12,border:"1px solid var(--border)"}}>
            {event.description}
          </div>
        )}

        {partCount>0&&(
          <div style={{marginBottom:24,padding:"12px 16px",background:"var(--surface2)",borderRadius:12,border:"1px solid var(--border)"}}>
            <div style={{fontSize:16,color:"var(--muted)",marginBottom:3}}>
              {partCount===1?"1 musicista partecipa già":`${partCount} musicisti partecipano già`}
            </div>
            <div style={{fontSize:16,fontWeight:600}}>
              {partNames.join(", ")}{partCount>5?` e altri ${partCount-5}`:""}
            </div>
          </div>
        )}

        {/* Due pulsanti della stessa misura: chi ha gia' un account (magari da
            una serata precedente) deve trovare il suo subito quanto chi arriva
            per la prima volta. Il calendario qui non c'e': si aggiunge dopo,
            dalla pagina della serata. */}
        <button className="btn btn-primary" style={{...bottoneInvito,border:"2px solid #ED4D1D"}}
          onClick={onRegister}>
          Clicca e registrati all'evento
        </button>
        <button className="btn" style={{...bottoneInvito,marginTop:12,background:"transparent",color:"#fff",border:"2px solid #ED4D1D"}}
          onClick={onLogin}>
          Ho già un account: accedi
        </button>
      </div>
    </div>
  );
}

export default EventPreview;
